// src/components/checkout/columns.js

import React from "react";
import { Row, Col, Avatar, Typography } from "antd";

const { Text } = Typography;

const getColumns = (screens = {}) => [
  {
    title: "Product",
    dataIndex: "product",
    key: "product",
    render: (product, record) => (
      <Row align="middle" gutter={screens.xs ? 8 : 12} wrap={false}>
        <Col flex="none">
          <Avatar
            shape="square"
            src={`${product.images}?v=${product.imageVersion}`}
            size={screens.xs ? 40 : 64}
            style={{ borderRadius: "6px" }}
          />
        </Col>
        <Col flex="auto" style={{ minWidth: 0 }}>
          <Text
            strong
            style={{
              fontSize: screens.xs ? "13px" : "16px",
              display: "block",
              lineHeight: 1.2,
              wordBreak: "break-word",
            }}
          >
            {product.name}
          </Text>

          {/* Inline Qty & Price details on mobile */}
          {screens.xs && (
            <Text
              type="secondary"
              style={{
                fontSize: "11px",
                display: "block",
                whiteSpace: "nowrap",
              }}
            >
              Qty: {record.quantity} × ${record.price.toFixed(2)}
            </Text>
          )}
        </Col>
      </Row>
    ),
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
    align: "center",
    responsive: ["sm"], // Hides on mobile (xs)
  },
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
    align: "center",
    responsive: ["sm"], // Hides on mobile (xs)
    render: (price) => `$${price.toFixed(2)}`,
  },
  {
    title: "Total",
    dataIndex: "total",
    key: "total",
    align: "center",
    width: screens.xs ? 80 : undefined,
    render: (total) => (
      <Text
        strong
        style={{
          fontSize: screens.xs ? "13px" : "16px",
          whiteSpace: "nowrap", // Prevents dollar amount from wrapping onto a second line
        }}
      >
        ${total.toFixed(2)}
      </Text>
    ),
  },
];

export default getColumns;
